import React, { useState, useReducer, useRef, useEffect, useImperativeHandle, forwardRef } from "react";


import CustomDropDown from "../CustomDropDown/CustomDropDown";

import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import classes from './InviteUserForm.module.css';

import ToggleInput from "../UI/ToggleInput";
import Input from "../CustomDropDown/Input/Input";
import { inviteUser } from "../../Api Methods/Api";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";


const extraLinks = [
    {
        LinkTextBold: "Subscribe to get release emails",
    },
]

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const emailReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: emailRegex.test(action.val) };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}

// Reducer function
const userRoleReducer = (state, action) => {

    if (action.type === 'TOGGLE_DROPDOWN') {
        return { ...state, showDropDownOptions: !state.showDropDownOptions, isValid: null };
    }

    if (action.type === 'SELECT_OPTION') {
        return { ...state, selectedOption: action.payload, showDropDownOptions: false, isValid: action.val != "UserRole" };
    }

    if (action.type === 'BLUR_DROPDOWN') {
        return { ...state, showDropDownOptions: false, isValid: action.val != "UserRole" };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { selectedOption: null, isValid: null };
    }
    //otherwise 
    return { state };
};


const InviteUserForm = ({ apiData, DeviceId, userID, userRole, userEmail, DeviceName, label, HandleCloseModal, HandleDeviceUserList, companyName, setUserAdded, setFailedToAdd, setFailMessage }, props) => {

    console.log(DeviceName);
    const [formIsValid, setFormIsValid] = useState(false);

    const [emailState, dispatchEmail] = useReducer(emailReducer, {
        value: '',
        isValid: null
    });

    const [confirmEmailState, confirmDispatchEmail] = useReducer(emailReducer, {
        value: '',
        isValid: null
    });

    // UserRole Drop Down reducer  ----------------
    const [userRoleState, dispatchUserRole] = useReducer(userRoleReducer, {
        showDropDownOptions: false,
        selectedOption: '', // Initial selectedOption state
        isValid: null
    });

    const { showDropDownOptions: showUserRoleDropDownOptions, selectedOption: selectedUserRoleOption } = userRoleState;

    const emailInputRef = useRef();
    const confirmEmailInputRef = useRef();
    const userRoleDropdownRef = useRef();

    const { isValid: emailIsValid } = emailState;
    const { isValid: confirmEmailIsValid} = confirmEmailState
    const { isValid: userRoleIsValid } = userRoleState;

    useEffect(() => {
        const identifier = setTimeout(() => {
            const emailsMatch = emailState.value === confirmEmailState.value;
            setFormIsValid(emailIsValid && confirmEmailIsValid && userRoleIsValid && emailsMatch);
        }, 500);
    
        return () => {
            clearTimeout(identifier);
        };
    }, [emailIsValid, confirmEmailIsValid, userRoleIsValid, emailState.value, confirmEmailState.value]);
    

    const emailChangeHandler = (event) => {
        dispatchEmail({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }

    const confirmEmailChangeHandler = (event) => {
        const value = event.target.value;
        const isValid = emailRegex.test(value) && value === emailState.value;
        confirmDispatchEmail({ type: 'USER_INPUT', val: value, isValid });
    };
    

    const validateEmailHandler = () => {
        dispatchEmail({ type: 'INPUT_BLUR' });
    }

    const validateConfirmEmailHandler = () => {
        confirmDispatchEmail({ type: 'INPUT_BLUR' });
    }

    // Drop down handlers ---------------
    const handleUserRoleDropDownOnClick = () => {
        dispatchUserRole({ type: 'TOGGLE_DROPDOWN' });
    };

    const handleUserRoleOptionChange = (option) => {
        dispatchUserRole({ type: 'SELECT_OPTION', payload: option });
    };
    const handleUserRoleBlur = () => {
        dispatchUserRole({ type: 'BLUR_DROPDOWN' });
    };

    const onClearHandler = () => {
        dispatchEmail({ type: 'INPUT_CLEAR', val: "" })
        dispatchUserRole({ type: 'INPUT_CLEAR', val: "" })
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [startDateTime, setStartDateTime] = useState('')
    const [endDateTime, setEndDateTime] = useState('')
    const [isTemp, setIsTemp] = useState(false)
    const [appAdmin, setAppAdmin] = useState(false)

    const submitHandler = (event) => {
        event.preventDefault();

        if (formIsValid) {

            const email = emailState.value;
            let userRole = userRoleState.selectedOption;
            let liveViewAccess = 0
            

            if (userRoleState.selectedOption == "App manager"){
                userRole = "Manager"
            } else if (userRoleState.selectedOption == "App admin"){
                userRole = "Manager"
                appAdmin = 1
                liveViewAccess = 1
            } else if (userRoleState.selectedOption == "App manager plus"){
                userRole = "Manager"
                liveViewAccess = 1
            } else {
                userRole = "User"
            }

            inviteUser(apiData, DeviceId, userID, userRole, email, DeviceName, companyName, appAdmin == true ? 1 : 0, liveViewAccess, startDateTime, endDateTime, isTemp, dispatch).then((responseData) => {
                if (responseData.success){
                    //HandleCloseModal();
                    //HandleDeviceUserList();
                    setUserAdded(true);
                } else {
                    setFailMessage(responseData.msg)
                    setFailedToAdd(true)
                }
            })

            onClearHandler();

            return;

        } else if (!emailIsValid) {
            emailInputRef.current.focus();
        } else if (!confirmEmailIsValid){
            confirmEmailInputRef.current.focus();
        } else if (!userRoleIsValid) {
            userRoleDropdownRef.current.focus();
        }
    };

    return (
        <form onSubmit={submitHandler} className={classes["container"]} method="dialog" >
            <ul className={classes["inputs-list"]}>
            
                <li className={classes["input-container"]}>
                    <Input
                        className={classes.input}
                        placeholder={"Enter user's email address"}
                        ref={emailInputRef}
                        id="Email"
                        type={"text"}
                        isValid={emailState.isValid}
                        value={emailState.value}
                        onChange={emailChangeHandler}
                        onBlur={validateEmailHandler}
                    />

                    <Input
                        className={classes.input}
                        placeholder={"Confirm user email address"}
                        ref={confirmEmailInputRef}
                        id="ConfirmEmail"
                        type={"text"}
                        isValid={confirmEmailState.isValid}
                        value={confirmEmailState.value}
                        onChange={confirmEmailChangeHandler}
                        onBlur={validateConfirmEmailHandler}
                    />

                    <Dropdown
                        value={selectedUserRoleOption}
                        onChange={(e) => handleUserRoleOptionChange(e.value)}
                        options={['App standard user', 'App manager', 'App manager plus']}
                        placeholder="Select Role"
                        className="w-full"
                    />
                </li>

                <div className={classes["checkbox-container"]}>
                    <Checkbox onChange={e => setIsTemp(!isTemp)} checked={isTemp} name='Temporary access?'></Checkbox>
                    <label className="ml-2">   Temporary access</label>
                </div>

                {/* <div className={classes["checkbox-container"]}>
                    <Checkbox onChange={e => setAppAdmin(!appAdmin)} checked={appAdmin} name='App admin?'></Checkbox>
                    <label className="ml-2">   Enable App Admin</label>
                </div> */}
                
                {isTemp && 
                    <div className={classes["dateTime-container"]}>
                        {/* <p>From: </p>
                        <Calendar value={startDateTime} onChange={(e) => setStartDateTime(e.value)} showTime hourFormat="24" dateFormat="dd/mm/yy" /> */}
                        <p>Until: </p>
                        <Calendar value={endDateTime} onChange={(e) => setEndDateTime(e.value)} showTime hourFormat="24" dateFormat="dd/mm/yy" />
                    </div>
                }

                <div className={classes["button-container"]}>
                    <Button icon="pi pi-check" className={classes.submitButton} type="submit" label='Invite' severity="success"/>
                </div>
            </ul>

        </form>


    )


}

export default InviteUserForm;

